(() => {
  'use strict';

  const DESKTOP_MQ = '(min-width: 1280px)';
  const HOVER_MQ = '(hover: hover) and (pointer: fine)';

  /* ---------- Proportional keyboard / gear icons ---------- */
  const PAL = {
    cream: { c: '#E7DFD0', k: '#F8F3EA', m: '#C9BBA3', a: '#A8322D' },
    slate: { c: '#3B4048', k: '#EEEEEE', m: '#7D8795', a: '#E0A82E' },
    gray: { c: '#A9ADB4', k: '#FFFFFF', m: '#DCDFE3', a: '#DCDFE3' },
    night: { c: '#2A2C30', k: '#F4F4F4', m: '#4A4E57', a: '#E0A82E' },
    lilac: { c: '#4A4263', k: '#F0ECF6', m: '#9A8FBE', a: '#E0A82E' },
    frost: { c: '#E4E4E8', k: '#FAFAFB', m: '#CFCDD8', a: '#8BC6E8' },
    ice: { c: '#D6E6EF', k: '#FFFFFF', m: '#B7D3E3', a: '#5AA7D1' },
  };
  const LAY = {
    '60': { w: 15, r: 5 },
    '65': { w: 16, r: 5 },
    '75': { w: 16, r: 6 },
    tkl: { w: 17, r: 6 },
    '85': { w: 19, r: 6 },
    '96': { w: 18.25, r: 6, g: [[15, 15.25]] },
    full: { w: 22.5, r: 6, g: [[15, 15.25], [18.25, 18.5]] },
  };
  const U = 10;
  const PAD = 5;
  const GAP = 1.8;
  const svgW = (t) => LAY[t].w * U + PAD * 2;
  const maxW = svgW('full');

  function kb(type, palName) {
    const L = LAY[type] || LAY['75'];
    const p = PAL[palName] || PAL.frost;
    const gaps = L.g || [];
    const frow = L.r === 6 ? 3 : 0;
    const W = svgW(type in LAY ? type : '75');
    const H = L.r * U + frow + PAD * 2;
    const mainEnd = gaps.length ? gaps[0][0] : L.w;
    let s = `<svg viewBox="0 0 ${W} ${H}" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><rect width="${W}" height="${H}" rx="5" fill="${p.c}"/>`;
    for (let r = 0; r < L.r; r++) {
      const y = PAD + r * U + (frow && r > 0 ? frow : 0);
      const bottom = r === L.r - 1;
      const keys = [];
      let x = 0;
      if (bottom) {
        keys.push([0, 1.25, 'm'], [1.25, 1.25, 'm'], [2.5, 1.25, 'm'], [3.75, 6.25, 'k']);
        x = 10;
      }
      while (x < L.w - 0.01) {
        const hit = gaps.find((g) => x >= g[0] - 0.01 && x < g[1] - 0.01);
        if (hit) {
          x = hit[1];
          continue;
        }
        keys.push([x, 1, bottom ? 'm' : 'k']);
        x += 1;
      }
      keys.forEach((k, i) => {
        let tone = k[2];
        if (!bottom && (i === 0 || Math.abs(k[0] + k[1] - mainEnd) < 0.01)) tone = 'm';
        if (r === 0 && i === 0) tone = 'a';
        s += `<rect x="${(PAD + k[0] * U + GAP / 2).toFixed(2)}" y="${(y + GAP / 2).toFixed(2)}" width="${(k[1] * U - GAP).toFixed(2)}" height="${U - GAP}" rx="1.6" fill="${p[tone]}"/>`;
      });
    }
    return s + '</svg>';
  }

  const mouse = () =>
    `<svg viewBox="0 0 80 110" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M40 6c19 0 30 16 30 40v22c0 22-13 36-30 36S10 90 10 68V46C10 22 21 6 40 6z" fill="#2A2C30"/><path d="M40 7v33M11 40h58" stroke="#5A5F66" stroke-width="2"/><rect x="36" y="15" width="8" height="17" rx="4" fill="#E0A82E"/></svg>`;
  const headset = (pro) =>
    `<svg viewBox="0 0 120 110" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M25 62V52c0-22 16-38 35-38s35 16 35 38v10" fill="none" stroke="#2A2C30" stroke-width="7" stroke-linecap="round"/><rect x="14" y="52" width="22" height="40" rx="10" fill="#2A2C30"/><rect x="84" y="52" width="22" height="40" rx="10" fill="#2A2C30"/><rect x="19" y="61" width="4" height="22" rx="2" fill="#E0A82E"/><rect x="97" y="61" width="4" height="22" rx="2" fill="#E0A82E"/>${
      pro
        ? '<path d="M22 90c2 10 12 14 26 14" fill="none" stroke="#2A2C30" stroke-width="4" stroke-linecap="round"/><circle cx="50" cy="104" r="4.5" fill="#E0A82E"/>'
        : ''
    }</svg>`;

  function paintIcons(root) {
    root.querySelectorAll('[data-rk-kb]').forEach((el) => {
      const type = el.getAttribute('data-rk-kb') || '75';
      const pal = el.getAttribute('data-rk-pal') || 'gray';
      el.innerHTML = kb(type in LAY ? type : '75', pal);
      if (el.classList.contains('rk-nav__thumb') && el.firstChild) {
        el.firstChild.style.width = ((svgW(type in LAY ? type : '75') / maxW) * 48).toFixed(1) + 'px';
      }
    });
    root.querySelectorAll('[data-rk-mouse]').forEach((el) => {
      el.innerHTML = mouse();
    });
    root.querySelectorAll('[data-rk-headset]').forEach((el) => {
      el.innerHTML = headset(el.getAttribute('data-rk-headset') === 'pro');
    });
  }

  /* ---------- Nav behaviour ---------- */
  function initNav(root) {
    const nav = root.querySelector('[data-rk-nav]');
    if (!nav || nav.dataset.rkBound === 'true') return;
    nav.dataset.rkBound = 'true';

    const wrapper = nav.closest('.header-wrapper') || document.querySelector('.header-wrapper');
    const scrim = document.querySelector('[data-rk-nav-scrim]');
    const desktopMQ = window.matchMedia(DESKTOP_MQ);
    const hoverMQ = window.matchMedia(HOVER_MQ);
    const isDesktop = () => desktopMQ.matches;
    const canHover = () => isDesktop() && hoverMQ.matches;

    const allItems = [...nav.querySelectorAll('.rk-nav__item')];
    const menuItems = allItems.filter((li) => li.querySelector('.rk-nav__trigger'));
    const tops = [...nav.querySelectorAll('.rk-nav__top')];
    const btnOf = (li) => li.querySelector('.rk-nav__trigger');
    const panelOf = (li) => li.querySelector('.rk-nav__panel');

    let current = null;
    let openedAt = 0;
    let tOpen;
    let tClose;

    function setHeaderLock(on) {
      if (wrapper) wrapper.preventHide = !!on;
      if (on && wrapper) {
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${Math.floor(wrapper.getBoundingClientRect().bottom)}px`
        );
      }
    }

    function updateScrim() {
      if (!scrim) return;
      const show = isDesktop() && current && current.dataset.mega === 'true';
      scrim.hidden = !show;
    }

    function openItem(li) {
      if (current === li) return;
      if (current) closeItem(current);
      li.classList.add('is-open');
      const btn = btnOf(li);
      const panel = panelOf(li);
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (panel) panel.hidden = false;
      current = li;
      openedAt = Date.now();
      setHeaderLock(true);
      updateScrim();
    }

    function closeItem(li) {
      li.classList.remove('is-open');
      const btn = btnOf(li);
      const panel = panelOf(li);
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      if (current === li) current = null;
      setHeaderLock(!!current);
      updateScrim();
    }

    const closeAll = () => {
      if (current) closeItem(current);
    };

    menuItems.forEach((li) => {
      btnOf(li).addEventListener('click', () => {
        if (current === li) {
          if (canHover() && Date.now() - openedAt < 500) return;
          closeItem(li);
        } else {
          openItem(li);
        }
      });
      li.addEventListener('focusout', (e) => {
        if (isDesktop() && current === li && !li.contains(e.relatedTarget)) closeItem(li);
      });
    });

    allItems.forEach((li) => {
      const hasMenu = !!li.querySelector('.rk-nav__trigger');
      li.addEventListener('mouseenter', () => {
        if (!canHover()) return;
        clearTimeout(tOpen);
        clearTimeout(tClose);
        tOpen = setTimeout(() => (hasMenu ? openItem(li) : closeAll()), current ? 0 : 140);
      });
      li.addEventListener('mouseleave', () => {
        if (canHover()) clearTimeout(tOpen);
      });
    });

    const hoverRoot = wrapper || nav;
    hoverRoot.addEventListener('mouseleave', () => {
      if (!canHover()) return;
      clearTimeout(tOpen);
      tClose = setTimeout(closeAll, 220);
    });
    hoverRoot.addEventListener('mouseenter', () => clearTimeout(tClose));

    nav.addEventListener('keydown', (e) => {
      const t = e.target;
      if (e.key === 'Escape') {
        if (current) {
          const b = btnOf(current);
          closeItem(current);
          if (b) b.focus();
          e.preventDefault();
        }
        return;
      }
      if (!isDesktop()) return;
      const idx = tops.indexOf(t);
      if (idx < 0) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        const wasOpen = !!current;
        const next = tops[(idx + (e.key === 'ArrowRight' ? 1 : -1) + tops.length) % tops.length];
        next.focus();
        if (wasOpen) {
          const li = next.closest('.rk-nav__item');
          li && li.querySelector('.rk-nav__panel') ? openItem(li) : closeAll();
        }
      } else if (e.key === 'ArrowDown' && t.classList.contains('rk-nav__trigger')) {
        e.preventDefault();
        const li = t.closest('.rk-nav__item');
        openItem(li);
        const first = panelOf(li).querySelector('a[href], button');
        if (first) first.focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!isDesktop() || !current) return;
      if (current.contains(e.target)) return;
      if (scrim && e.target === scrim) {
        closeAll();
        return;
      }
      closeAll();
    });

    if (scrim) {
      scrim.addEventListener('click', closeAll);
    }

    desktopMQ.addEventListener('change', closeAll);

    paintIcons(nav);
  }

  function initMobileDrawer(root) {
    const drawer = (root || document).querySelector('.menu-drawer.rk-mnav');
    if (!drawer || drawer.dataset.rkMnavReady === '1') return;
    drawer.dataset.rkMnavReady = '1';

    const setSub = (section, open) => {
      section.classList.toggle('is-open', open);
      const btn = section.querySelector('[data-rk-mnav-sub]');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const closeSubs = (scope) => {
      (scope || drawer).querySelectorAll('.rk-mnav__sub.is-open').forEach((section) => setSub(section, false));
    };

    const setPanel = (item, open) => {
      const btn = item.querySelector('[data-rk-mnav-toggle]');
      const panel = item.querySelector('.rk-mnav__panel');
      if (!open) closeSubs(item);
      item.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    };

    const closeAllAcc = () => {
      drawer.querySelectorAll('.rk-mnav__item.is-open').forEach((item) => setPanel(item, false));
      closeSubs(drawer);
    };

    drawer.querySelectorAll('[data-rk-mnav-sub]').forEach((btn) => {
      btn.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          const section = btn.closest('.rk-mnav__sub');
          if (!section) return;
          setSub(section, !section.classList.contains('is-open'));
        },
        true
      );
    });

    drawer.querySelectorAll('[data-rk-mnav-toggle]').forEach((btn) => {
      btn.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          const item = btn.closest('.rk-mnav__item');
          if (!item) return;
          const willOpen = !item.classList.contains('is-open');
          closeAllAcc();
          if (willOpen) setPanel(item, true);
        },
        true
      );
    });

    const closeBtn = drawer.querySelector('[data-rk-mnav-close]');
    if (closeBtn) {
      closeBtn.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          const details = drawer.closest('details');
          const summary = details && details.querySelector(':scope > summary');
          if (summary) summary.click();
        },
        true
      );
    }

    const hostDetails = drawer.closest('details');
    if (hostDetails) {
      hostDetails.addEventListener('toggle', () => {
        if (!hostDetails.open) closeAllAcc();
      });
    }

    paintIcons(drawer);
  }

  function boot(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-rk-nav]').forEach((nav) => initNav(nav.parentElement || document));
    initMobileDrawer(root);
    paintIcons(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
